import { render } from "./TemperatureReport.vue?vue&type=template&id=2801359c"
import script from "./TemperatureReport.vue?vue&type=script&lang=js"
export * from "./TemperatureReport.vue?vue&type=script&lang=js"

import "./TemperatureReport.vue?vue&type=style&index=0&id=2801359c&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__